export const SportUpcomingEventsSkeleton = () => {
  return (
    <div className="vgp-sport-upcoming-events">
      <div className="vgp-sport-upcoming-event" />
      <div className="vgp-sport-upcoming-event" />
      <div className="vgp-sport-upcoming-event" />
    </div>
  );
};
